import { func, string } from 'prop-types';
import React from 'react';

import { ReactComponent as Glass } from '~assets/glass.svg';

import styles from './styles.module.scss';

const SearchInput = ({ handleInput, searcherClassName }) => {
  return (
    <div className={`${styles.inputContainer} ${searcherClassName}`}>
      <input onChange={handleInput} className="full-width" />
      <Glass />
    </div>
  );
};

SearchInput.propTypes = {
  handleInput: func,
  searcherClassName: string
};

export default SearchInput;
